import { setRoamingTimezones } from '../data/mutators/roamingTimezonesMutators';
import RoamingTimezone from '../data/store/schema/RoamingTimezone';
import { getDefaultVisibleRoamingTimezones, TimezoneInfo } from 'owa-calendar-cloud-settings';

export default function loadRoamingTimeZones() {
    const roamingTimezonesOCS: TimezoneInfo[] = getDefaultVisibleRoamingTimezones();
    const roamingTimezones: RoamingTimezone[] = [];

    roamingTimezonesOCS.forEach(roamingTimezone => {
        roamingTimezones.push({
            timezoneId: roamingTimezone.timezoneId,
            timezoneLabel: roamingTimezone.timezoneLabel,
        });
    });
    setRoamingTimezones(roamingTimezones);
}
